<!--
  Implementation

  -in template:
  <expanding-list :list="markedCounters"
                        :title="$t('servicesystem.common_objects.machine.machine_counters')"
                        :icon="'mdi-counter'"
                        :listitem="{key: 'CounterId', textkey: 'Name'}">
  </expanding-list>


  counterData                                               = the list
  'servicesystem.common_objects.machine.machine_counters'    = i18n key
  'mdi-counter'                                             = icon key
  {key: 'CounterId', textkey: 'Name'}                       = config and import for list items used in the list (defines what keys and what list item component to use)

-->

<template>
  <slotted-expancion-panel :title="title"
                           :icon="icon"
                           :helpertext="helperText"
                           :disabled="/*!hasElements ||*/  loading">
    <template v-slot:header-hint>
      <slot name="panel-header-hint">
        <div v-if="loading" class="d-flex justify-end mr-3">
          <v-progress-circular size="20"
                               width="3"
                               indeterminate
                               color="primary">
          </v-progress-circular>
        </div>
        <card-badge v-else-if="cardcount"
                    :color="hasElements ? 'primary' : 'disabled'"
                    :count="hasElements ? list.length : 0"
                    :donthide="true"
                    :class="'mr-3'">
        </card-badge>
      </slot>
    </template>
    <template v-slot:header-outer>
      <slot name="panel-header-outer" />
    </template>
    <template v-slot:content>
      <QScroll v-if="!loading"
               :list="list"
               :height="maxcontentheight ? maxcontentheight : 296">
        <template v-slot:list-item="{ item }">
          <slot name="list-item"
                :item="item" />
        </template>
      </QScroll>
      <v-progress-linear v-else
                         indeterminate
                         color="primary">
      </v-progress-linear>
    </template>
  </slotted-expancion-panel>
</template>

<script>
import SlottedExpancionPanel from "@/views/layouts/SlottedExpancionPanel.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import CardBadge from "@/components/Buttons/CardBadge.vue";

export default {
  name: "ExpandingList",
  props: ["list", "title", "icon", "maxcontentheight", "listitem", "loading", "cardcount"],
  components: {
    SlottedExpancionPanel,
    QScroll,
    CardBadge,
  },

  data: () => ({}),

  created() {},

  mounted() {},

  methods: {},

  computed: {
    hasElements() {
      return this.list && this.list.length && this.list.length > 0;
    },

    helperText() {
      var listcount = this.hasElements ? this.list.length : 0;
      var suffix = this.title ? this.title : "elements";
      return this.loading ? "" : listcount + " " + suffix;
    },
  },

  watch: {},
};
</script>


<style lang="scss">
</style>